/**
 * Identity
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface PartialUpdateUserInternalRequestOperation { 
    path?: string | null;
    op?: string | null;
    from?: string | null;
    value?: any | null;
}

